import { FilterMatchMode } from 'primereact/api';

export const tableFilters = {
  armador: { value: null, matchMode: FilterMatchMode.CONTAINS },
  contenedor: { value: null, matchMode: FilterMatchMode.CONTAINS },
  tipo: { value: null, matchMode: FilterMatchMode.CONTAINS },
  tamano: { value: null, matchMode: FilterMatchMode.CONTAINS },
  peso: { value: null, matchMode: FilterMatchMode.CONTAINS },
  precinto1: { value: null, matchMode: FilterMatchMode.CONTAINS },
  precinto2: { value: null, matchMode: FilterMatchMode.CONTAINS },
  precinto3: { value: null, matchMode: FilterMatchMode.CONTAINS },
  precinto4: { value: null, matchMode: FilterMatchMode.CONTAINS },
  imos: { value: null, matchMode: FilterMatchMode.CONTAINS },
  uns: { value: null, matchMode: FilterMatchMode.CONTAINS },
  temperatura: { value: null, matchMode: FilterMatchMode.CONTAINS },
  ventilacion: { value: null, matchMode: FilterMatchMode.CONTAINS },
  humedad: { value: null, matchMode: FilterMatchMode.CONTAINS },
  viajeAnterior: { value: null, matchMode: FilterMatchMode.CONTAINS },
  status: { value: null, matchMode: FilterMatchMode.CONTAINS },
  destinoFinal: { value: null, matchMode: FilterMatchMode.CONTAINS },
  viajeCarga: { value: null, matchMode: FilterMatchMode.CONTAINS },
};
